import { EMBED_ELEMENTS_PREFIX } from "core/config";
import SiteCookiePolicy from "core/SiteCookiePolicy";
import SiteCookiesTable from "core/SiteCookiesTable";
import { type FunctionComponent } from "preact";
import classNames from "helpers/classNames";
import useTranslation from "hooks/useTranslation";
import EmbedContainer from "core/EmbedContainer/EmbedContainer";

const cx = classNames();
const CookieDeclaration: FunctionComponent<ICookieDeclarationProps> = ({
  layout = "table",
}) => {
  const { textDirection, userLang } = useTranslation();

  return (
    <EmbedContainer>
      {({ scan }) => (
        <div
          class={cx(`${EMBED_ELEMENTS_PREFIX}-cookie-declaration`)}
          dir={textDirection}
          lang={userLang}
        >
          <SiteCookiePolicy
            visitorId={scan.visitor_id}
            updatedAt={scan.cookie_policy_updated_at}
            cookies={scan.cookies}
          />
          <SiteCookiesTable
            layout={layout}
            cookies={scan.cookies}
            updatedAt={scan.cookie_list_updated_at}
          />
        </div>
      )}
    </EmbedContainer>
  );
};
export interface ICookieDeclarationProps {
  layout?: "table" | "alternate";
}

export default CookieDeclaration;
